import { NgModule } from '@angular/core';
import { AppLayoutComponent } from './app-layout/app-layout/app-layout.component';
import { RouterModule, Routes } from '@angular/router';
import {LoginComponent} from './login/login.component';
import {PrincipalComponent} from './principal/principal.component';
import {ConfiguracionComponent} from './configuracion/configuracion.component';
import {CasillasMailComponent} from './casillas-mail/casillas-mail.component';
import {ConsorciosComponent} from './consorcios/consorcios.component';
import {TiposDocumentoComponent} from './tipos-documento/tipos-documento.component';
import {TiposDomicilioComponent} from './tipos-domicilio/tipos-domicilio.component';
import {TiposMailsComponent} from './tipos-mails/tipos-mails.component';
import {TiposSexoComponent} from './tipos-sexo/tipos-sexo.component';
import {ObrasSocialesComponent} from './obras-sociales/obras-sociales.component';
import {ProvinciasComponent} from './provincias/provincias.component';
import {LocalidadComponent} from './localidad/localidad.component';
import {TiposTelefonosComponent} from './tipos-telefonos/tipos-telefonos.component';
import {PrestacionesComponent} from './prestaciones/prestaciones.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  { path: 'login',component:LoginComponent, data: {animation: 'Entra'} },
  {
    path: '', 
    component: AppLayoutComponent, data: {animation: "Entra" },
    children: [
      { path: 'principal',  component: PrincipalComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'configuracion',  component: ConfiguracionComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'casillasMails',  component: CasillasMailComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'consorcios',  component: ConsorciosComponent , data: {animation: "Entra", title: "Inicio"}},
      
      { path: 'tiposDomicilio',  component: TiposDomicilioComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'tiposMails',  component: TiposMailsComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'tiposSexo',  component: TiposSexoComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'obrasSociales',  component: ObrasSocialesComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'provincias',  component: ProvinciasComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'localidades',  component: LocalidadComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'tiposTelefonos',  component: TiposTelefonosComponent , data: {animation: "Entra", title: "Inicio"}},
      { path: 'prestaciones',  component: PrestacionesComponent , data: {animation: "Entra", title: "Inicio"}},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
